import classNames from "classnames";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Button, HelperText, Link, Spinner, Text, TextInput } from "../../components";
/**
 * @typedef {{ email: string }} ForgotPasswordSubmission
 *
 * @typedef {object} ForgotPasswordProps
 * @property {{ email: boolean }} [errors]
 * @property {React.FC<{ href: string, className?: any }>} Link
 * @property {{ login: string }} [links]
 * @property {(value: ForgotPasswordSubmission) => Promise<any>} onSubmit
 * @property {any} [className]
 */

/**
 * @type {React.FC<ForgotPasswordProps & { [key: string]: any }>}
 */

export const ForgotPassword = ({
  className,
  onSubmit,
  Link,
  links,
  children,
  errors
}) => {
  /** @type {ReactState<boolean>} */
  const [isLoading, setIsLoading] = useState(false);
  const {
    handleSubmit,
    register,
    errors: formErrors,
    formState
  } = useForm({
    mode: "onChange",
    defaultValues: {
      email: ""
    }
  });
  const {
    isValid
  } = formState;
  /** @param {ForgotPasswordSubmission} values */

  const onFormSubmit = async values => {
    setIsLoading(true);
    return onSubmit(values).finally(() => {
      setIsLoading(false);
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classNames("bg-white rounded p-8 shadow", className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-3xl text-center font-bold py-4 text-en-gray-800"
  }, "Reset Password"), /*#__PURE__*/React.createElement("div", {
    className: "text-center pt-2 pb-4 font-light"
  }, "Enter the email address associated with your account to reset your password."), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("form", {
    name: "forgot-password",
    onSubmit: handleSubmit(onFormSubmit)
  }, children ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, children), /*#__PURE__*/React.createElement("div", {
    className: "py-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "py-4 text-center"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "mt-4 px-12"
  }, isLoading ? /*#__PURE__*/React.createElement(Spinner, {
    size: "1.1rem",
    className: "p-0 -mb-1"
  }) : "Resend Email"))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "py-2"
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "forgot-password-email",
    name: "email",
    placeholder: "Email",
    className: "w-full",
    valid: !formErrors.email && !errors?.email,
    type: "email",
    ref: register({
      required: "Please provide your Email address"
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-left"
  }, formErrors.email ? /*#__PURE__*/React.createElement(HelperText, {
    valid: false
  }, formErrors.email.message) : null)), /*#__PURE__*/React.createElement("div", {
    className: "py-4 text-center"
  }, /*#__PURE__*/React.createElement(Button, {
    className: {
      "mt-4 px-8": true,
      "px-4": false
    },
    disabled: isLoading || !isValid
  }, isLoading ? /*#__PURE__*/React.createElement(Spinner, {
    size: "1.1rem",
    className: "p-0 -mb-1"
  }) : "Continue")), /*#__PURE__*/React.createElement("div", {
    className: "py-2 text-center text-sm text-en-gray-400 font-light"
  }, "Remember Password?", " ", /*#__PURE__*/React.createElement(Link, {
    className: "underline font-bold",
    href: links.login
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    variant: "light",
    className: "inline"
  }, "Log in")))))));
};
ForgotPassword.defaultProps = {
  className: "block w-full",
  links: {
    login: "/login"
  },
  Link,
  onSubmit: async () => {},
  errors: {
    email: false
  }
};
ForgotPassword.propTypes = {
  className: PropTypes.any,
  onSubmit: PropTypes.func,
  Link: PropTypes.func,
  links: PropTypes.any,
  children: PropTypes.any,
  errors: PropTypes.any
};